import { api } from '..'
import { TLoraDevice } from 'shared/types'
import { useQuery } from '@tanstack/react-query'

export const getDevice = (deviceId: string) =>
  api
    .get<TLoraDevice>(`/v1/lorawan/devices/${deviceId}`)
    .then(({ data }) => data)

export const useGetLoraDevice = (deviceId?: string) => {
  if (!deviceId) throw new Error('Missing deviceId')
  return useQuery({
    queryFn: () => getDevice(deviceId),
    queryKey: ['loradevice', deviceId],
  })
}
